import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const ProformaInvoiceStatusFilter = ({ value = '', onChange }) => {
  const { proformaInvoices: pi } = useTranslatedMessages();
  const statusFilter = pi?.status_filter ?? {};
  const options_t = statusFilter?.options ?? {};

  const options = [
    { value: 'DRAFT', label: options_t?.draft ?? 'Draft' },
    { value: 'CREATED', label: options_t?.created ?? 'Created' },
  ];
  const selectedOption = options.find((option) => option.value === value) || null;

  const handleChange = (_, selected) => {
    onChange(selected?.value || null);
  };

  return (
    <Autocomplete
      value={selectedOption}
      options={options}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, optionValue) => option?.value === optionValue?.value}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label={statusFilter?.label ?? 'Status'}
          variant="outlined"
          size="small"
          sx={{ minWidth: 200 }}
        />
      )}
      clearOnBlur={false}
    />
  );
};

export default ProformaInvoiceStatusFilter;
